/* PDFCommunity - v45 interactions.
   3. The hero network reacts to your files: when files land in a tool the
      light pulses race to the tool card (which glows gold), and when a
      download is ready the whole network flashes once.
   4. Drop anywhere: drag files over any part of the page and a large gold
      frame appears; the files go to the tool that fits them (switching tab
      if needed). Images on a page without "JPG to PDF" are handed over to
      that page (kept only in this browser, for one minute).
   5. Paste with Ctrl+V (Cmd+V): a screenshot or a copied file goes straight
      into the right tool.
   Files are only ever handed to the page's own tools; nothing is sent. */
(function () {
  'use strict';
  var LANG = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2);
  var T = {
    en: { pauseAnim: 'Pause background animation', playAnim: 'Play background animation', drop: 'Drop to add your files', to: 'They go to: {tool}', one: '1 file added to {tool}', many: '{n} files added to {tool}',
      nope: "This file type can't be used here. PDF, Word, PowerPoint and images work.", img: 'Images go to JPG to PDF. Opening it…',
      hint: 'Tip: you can also paste with {key}+V',
      launchFail: "This file could not be opened. Drag it onto the page or choose it with the button." },
    nl: { pauseAnim: 'Achtergrondanimatie pauzeren', playAnim: 'Achtergrondanimatie afspelen', drop: 'Laat los om je bestanden toe te voegen', to: 'Ze gaan naar: {tool}', one: '1 bestand toegevoegd aan {tool}', many: '{n} bestanden toegevoegd aan {tool}',
      nope: 'Dit bestandstype werkt hier niet. PDF, Word, PowerPoint en afbeeldingen wel.', img: 'Afbeeldingen gaan naar JPG naar PDF. Even openen…',
      hint: 'Tip: plakken met {key}+V kan ook',
      launchFail: "Dit bestand kon niet geopend worden. Sleep het naar de pagina of kies het met de knop." },
    fr: { pauseAnim: "Mettre en pause l'animation d'arrière-plan", playAnim: "Lancer l'animation d'arrière-plan", drop: 'Relâchez pour ajouter vos fichiers', to: 'Destination : {tool}', one: '1 fichier ajouté à {tool}', many: '{n} fichiers ajoutés à {tool}',
      nope: 'Ce type de fichier ne fonctionne pas ici. Les PDF, Word, PowerPoint et images, si.', img: 'Les images vont vers JPG en PDF. Ouverture…',
      hint: 'Astuce : vous pouvez aussi coller avec {key}+V',
      launchFail: "Impossible d'ouvrir ce fichier. Faites-le glisser sur la page ou choisissez-le avec le bouton." },
    de: { pauseAnim: 'Hintergrundanimation anhalten', playAnim: 'Hintergrundanimation abspielen', drop: 'Loslassen, um Ihre Dateien hinzuzufügen', to: 'Ziel: {tool}', one: '1 Datei zu „{tool}“ hinzugefügt', many: '{n} Dateien zu „{tool}“ hinzugefügt',
      nope: 'Dieser Dateityp funktioniert hier nicht. PDF, Word, PowerPoint und Bilder schon.', img: 'Bilder werden in „JPG in PDF“ geöffnet…',
      hint: 'Tipp: Einfügen mit {key}+V geht auch',
      launchFail: "Diese Datei konnte nicht geöffnet werden. Ziehen Sie sie auf die Seite oder wählen Sie sie über die Schaltfläche aus." },
    es: { pauseAnim: 'Pausar la animación de fondo', playAnim: 'Reproducir la animación de fondo', drop: 'Suelta para añadir tus archivos', to: 'Van a: {tool}', one: '1 archivo añadido a {tool}', many: '{n} archivos añadidos a {tool}',
      nope: 'Este tipo de archivo no funciona aquí. PDF, Word, PowerPoint e imágenes sí.', img: 'Las imágenes van a JPG a PDF. Abriendo…',
      hint: 'Consejo: también puedes pegar con {key}+V',
      launchFail: "No se pudo abrir este archivo. Arrástralo a la página o elígelo con el botón." },
    pt: { pauseAnim: 'Pausar a animação de fundo', playAnim: 'Reproduzir a animação de fundo', drop: 'Solte para adicionar seus arquivos', to: 'Vão para: {tool}', one: '1 arquivo adicionado a {tool}', many: '{n} arquivos adicionados a {tool}',
      nope: 'Este tipo de arquivo não funciona aqui. PDF, Word, PowerPoint e imagens, sim.', img: 'As imagens vão para JPG para PDF. Abrindo…',
      hint: 'Dica: também dá para colar com {key}+V',
      launchFail: "Não foi possível abrir este arquivo. Arraste-o para a página ou escolha-o com o botão." }, it: { pauseAnim: "Metti in pausa l'animazione di sfondo", playAnim: "Riproduci l'animazione di sfondo", drop: "Rilascia per aggiungere i tuoi file", to: "Destinazione: {tool}", one: "1 file aggiunto a {tool}", many: "{n} file aggiunti a {tool}",
      nope: "Questo tipo di file non si può usare qui. Funzionano PDF, Word, PowerPoint e immagini.", img: "Per le immagini si usa JPG in PDF. Apertura in corso…",
      hint: "Suggerimento: puoi anche incollare con {key}+V",
      launchFail: "Impossibile aprire questo file. Trascinalo sulla pagina o sceglilo con il pulsante." }, pl: { pauseAnim: "Wstrzymaj animację tła", playAnim: "Odtwórz animację tła", drop: "Upuść, aby dodać pliki", to: "Cel: {tool}", one: "Dodano 1 plik do: {tool}", many: "Dodano pliki ({n}) do: {tool}",
      nope: "Tego typu pliku nie można tu użyć. Działają PDF, Word, PowerPoint i obrazy.", img: "Do obrazów służy JPG na PDF. Otwieranie…",
      hint: "Wskazówka: możesz też wkleić skrótem {key}+V",
      launchFail: "Nie udało się otworzyć tego pliku. Przeciągnij go na stronę albo wybierz przyciskiem." }
  };
  var S = T[LANG] || T.en;
  var JPG_PAGES = /\/(jpg-to-pdf|jpg-naar-pdf|jpg-en-pdf|jpg-in-pdf|jpg-a-pdf|jpg-para-pdf)\.html$/;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMac = /Mac|iPhone|iPad/.test(navigator.platform || navigator.userAgent);
  var card = document.querySelector('.tool-card');
  if (!card) return;

  /* ---------- small helpers ---------- */
  function kind(f) {
    var n = (f.name || '').toLowerCase(), t = f.type || '';
    if (t === 'application/pdf' || /\.pdf$/.test(n)) return 'pdf';
    if (/\.(docx|pptx)$/.test(n)) return 'office'; // (v89) by name only, as the tools accept them (app.js getFileExt)
    if (/^image\/(jpeg|png|webp|gif|bmp|heic|heif|avif)$/.test(t) || /\.(jpe?g|jfif|png|webp|gif|bmp|heic|heif|avif)$/.test(n)) return 'image'; // (v89) + iPhone photos, as JPG to PDF accepts them
    return 'other';
  }
  function kindOfType(t) {
    if (t === 'application/pdf') return 'pdf';
    if (/officedocument\.(wordprocessingml|presentationml)/.test(t)) return 'office';
    if (/^image\//.test(t)) return 'image';
    return '';
  }
  function accepts(panel, k) {
    var input = panel && panel.querySelector('input[type=file]');
    if (!input) return false;
    var a = (input.getAttribute('accept') || '').toLowerCase();
    if (k === 'pdf') return a.indexOf('application/pdf') !== -1 || a.indexOf('.pdf') !== -1;
    if (k === 'office') return a.indexOf('.docx') !== -1 || a.indexOf('.pptx') !== -1;
    if (k === 'image') return a.indexOf('image/') !== -1;
    return false;
  }
  function tabs() {
    return [].filter.call(card.querySelectorAll('.tab'), function (t) { return getComputedStyle(t).display !== 'none'; });
  }
  // (v116) a tool whose panel still waits in its <template> (app.js pcMaterializePanel) is read from there,
  // so a dropped file still finds it; give() opens the tab first, which makes the real panel
  function panelOf(tab) {
    var id = 'panel-' + tab.dataset.tab, live = document.getElementById(id);
    if (live) return live;
    var tpl = document.querySelector('template[data-pc-panel="' + tab.dataset.tab + '"]');
    return tpl ? tpl.content.querySelector('#' + id) : null;
  }
  function activeTab() { return card.querySelector('.tab.active'); }
  function label(tab) { var s = tab && tab.querySelector('span'); return (s ? s.textContent : tab ? tab.textContent : '').trim(); }
  // the tab that should receive files of these kinds: the active one if it fits, else the first that does
  function tabFor(kinds) {
    var fits = function (tab) { var p = panelOf(tab); return kinds.every(function (k) { return accepts(p, k); }); };
    var a = activeTab();
    if (a && fits(a)) return a;
    var list = tabs();
    for (var i = 0; i < list.length; i++) if (fits(list[i])) return list[i];
    return null;
  }
  /* (v85) messages use the one toast helper of pc-extras.js (it loads
     first, on every page with this file), with its standard duration */
  function toast(msg) { window.PDFC_TOAST(msg); }
  /* (v90) a message about files that were not taken also stays under the
     drop zone of the tool (app.js PDFC_NOTES), not only in the passing toast */
  function dropzoneOf(tab) { var p = tab && panelOf(tab); return p && p.querySelector('.dropzone'); }
  function stay(msg, tab) {
    var dz = dropzoneOf(tab || activeTab());
    if (window.PDFC_NOTES && dz) window.PDFC_NOTES.show(dz, msg); else toast(msg);
  }
  function inView(el) { var r = el.getBoundingClientRect(); return r.top >= 0 && r.bottom <= window.innerHeight; }
  var ARRIVAL_RUSH_MS = 5000;
  function celebrateArrival() {
    card.classList.add('pc-glow');
    clearTimeout(card.__g); card.__g = setTimeout(function () { card.classList.remove('pc-glow'); }, 1400);
    if (window.PDFC_NET) window.PDFC_NET.rush(card, ARRIVAL_RUSH_MS); // (v104) long enough for people to see it
  }

  /* ---------- hand files to a tool ---------- */
  function give(tab, files) {
    if (!activeTab() || activeTab() !== tab) tab.click();
    var input = panelOf(tab).querySelector('input[type=file]');
    try {
      var dt = new DataTransfer();
      files.forEach(function (f) { dt.items.add(f); });
      input.files = dt.files;
    } catch (e) { return false; }
    input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }
  function route(files, how) {
    files = [].slice.call(files || []);
    if (!files.length) return;
    var docs = files.filter(function (f) { var k = kind(f); return k === 'pdf' || k === 'office'; });
    var imgs = files.filter(function (f) { return kind(f) === 'image'; });
    var done = [], given = false, taken = [];
    // (v89) an empty file is refused by the tool with its own message, so it isn't counted as added
    var count = function (list) { return list.filter(function (f) { return f.size > 0; }).length; };
    // ...and when some were left out, the tool's own "Not added" notice stays on screen
    var partial = false;
    var note = function (tab, list) { given = true; taken = taken.concat(list); if (count(list) < list.length) partial = true; if (count(list)) done.push([tab, count(list)]); };
    if (docs.length) {
      var kinds = []; docs.forEach(function (f) { var k = kind(f); if (kinds.indexOf(k) === -1) kinds.push(k); });
      var tab = tabFor(kinds) || tabFor(['pdf']);
      if (tab) {
        var use = docs.filter(function (f) { return accepts(panelOf(tab), kind(f)); });
        if (use.length && give(tab, use)) note(tab, use);
      }
    }
    if (imgs.length) {
      var itab = tabFor(['image']);
      if (itab) { if (give(itab, imgs)) note(itab, imgs); }
      // (v97) other files dropped with them are named on the JPG page (they used to vanish without a word)
      else if (!docs.length) { handOff(imgs, files.filter(function (f) { return imgs.indexOf(f) === -1; })); return; }
    }
    // (v90) what no tool took (other types, or pictures on a page without
    // JPG to PDF next to documents) is named, like in the drop zone itself
    var left = files.filter(function (f) { return taken.indexOf(f) === -1; });
    if (left.length && given && window.PDFC_NOTES) {
      var lastTab = done.length ? done[done.length - 1][0] : activeTab();
      window.PDFC_NOTES.notAdded(dropzoneOf(lastTab), left);
      partial = true;
    }
    if (!done.length) { if (!given) stay(S.nope); return; }
    var last = done[done.length - 1];
    if (!partial) toast((last[1] === 1 ? S.one : S.many).replace('{n}', last[1]).replace('{tool}', label(last[0])));
    if (!inView(card)) card.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    celebrateArrival();
  }

  /* ---------- images on a page without JPG to PDF: hand over ---------- */
  // (v117) readOnly: only open a database that is already there (a visit used to create an empty one each time)
  function idb(cb, readOnly) {
    try {
      var rq = indexedDB.open('pdfc-handoff', 1);
      rq.onupgradeneeded = function () { if (readOnly) rq.transaction.abort(); else rq.result.createObjectStore('files'); };
      rq.onsuccess = function () { cb(rq.result); };
      rq.onerror = function () { cb(null); };
    } catch (e) { cb(null); }
  }
  // (v90) the hash the JPG page reads (app.js PC_NEXT_NOFILE_HASH): "the files did not come along"
  var NOFILE_HASH = '#pc-nofile';
  function handOff(files, others) {
    var link = [].filter.call(document.querySelectorAll('footer a[href]'), function (a) { return JPG_PAGES.test(a.pathname); })[0];
    if (!link) { stay(S.nope); return; }
    stay(S.img);
    var noFile = function () { location.href = link.href.split('#')[0] + NOFILE_HASH; };
    idb(function (db) {
      if (!db) { noFile(); return; }
      // (v49) storage refusing the write (quota, private mode) must not
      // leave the visitor on this page after "taking you there…";
      // (v90) a full storage only ends the write with 'abort' (no 'error')
      try {
        var tx = db.transaction('files', 'readwrite');
        tx.objectStore('files').put({ at: Date.now(), files: files, others: (others || []).map(function (f) { return { name: f.name }; }) }, 'pending');
        tx.oncomplete = function () { db.close(); setTimeout(function () { location.href = link.href; }, 700); };
        tx.onerror = tx.onabort = function () { db.close(); noFile(); };
      } catch (e) { noFile(); }
    });
  }
  function receiveHandOff() {
    if (!tabFor(['image'])) return;
    idb(function (db) {
      if (!db) return;
      var tx, st, g;
      try { tx = db.transaction('files', 'readwrite'); st = tx.objectStore('files'); g = st.get('pending'); }
      catch (e) { db.close(); return; /* nothing was handed over, or storage is unavailable: the page works as usual */ }
      tx.oncomplete = tx.onabort = tx.onerror = function () { db.close(); }; // (v117) the connection was left open
      g.onsuccess = function () {
        var v = g.result; st.delete('pending');
        if (!(v && v.files && Date.now() - v.at < 60000)) return;
        setTimeout(function () {
          route(v.files, 'handoff');
          if (v.others && v.others.length && window.PDFC_NOTES) window.PDFC_NOTES.notAdded(dropzoneOf(tabFor(['image'])), v.others);
        }, 300);
      };
    }, true);
  }

  /* ---------- (v101) pause button for the calm background motion (WCAG 2.2.2) ---------- */
  (function () {
    var hero = document.querySelector('.hero'), net = window.PDFC_NET;
    if (!hero || !net || !net.movable) return;
    var PAUSE_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z"/></svg>';
    var PLAY_ICON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M8 5v14l11-7z"/></svg>';
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'hero-net-toggle';
    function paint() { var p = net.isPaused(); b.innerHTML = p ? PLAY_ICON : PAUSE_ICON; b.setAttribute('aria-label', p ? S.playAnim : S.pauseAnim); b.title = p ? S.playAnim : S.pauseAnim; } // (v115) the label says what a press does; no aria-pressed on top of that (a screen reader read 'pause, pressed')
    window.addEventListener('pdfc-net-state', paint);
    b.addEventListener('click', function () { net.setPaused(!net.isPaused()); paint(); });
    paint();
    hero.appendChild(b);
  })();

  /* ---------- 4. drop anywhere ---------- */
  var overlay = document.createElement('div');
  overlay.className = 'pc-drop';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.innerHTML = '<div class="pc-drop__box"><div class="pc-drop__msg"><strong></strong><span></span></div></div>';
  document.body.appendChild(overlay);
  var depth = 0;
  function hasFiles(e) { var t = e.dataTransfer && e.dataTransfer.types; return !!t && [].indexOf.call(t, 'Files') !== -1; }
  function dragKinds(e) {
    var ks = [];
    [].forEach.call((e.dataTransfer && e.dataTransfer.items) || [], function (it) {
      if (it.kind !== 'file') return; var k = kindOfType(it.type); if (k && ks.indexOf(k) === -1) ks.push(k);
    });
    return ks;
  }
  function showOverlay(e) {
    var ks = dragKinds(e), docs = ks.filter(function (k) { return k !== 'image'; });
    var tab = docs.length ? tabFor(docs) : ks.length ? tabFor(ks) : activeTab();
    overlay.querySelector('strong').textContent = S.drop;
    overlay.querySelector('span').textContent = tab ? S.to.replace('{tool}', label(tab)) : '';
    overlay.classList.add('on');
    card.classList.add('pc-glow'); // (v101) the card lights up while a file hangs over the page; the pulses race to it
    if (window.PDFC_NET) window.PDFC_NET.rush(card, 60000);
  }
  var DROP_TAIL_MS = 3500; // (v106) after a release the race goes on while the file is taken in, then thins out
  function hideOverlay(dropped) {
    depth = 0; overlay.classList.remove('on'); card.classList.remove('pc-glow');
    if (!window.PDFC_NET) return;
    if (dropped) window.PDFC_NET.rush(card, DROP_TAIL_MS); else window.PDFC_NET.stop();
  }
  function inDropzone(e) { return e.target && e.target.closest && e.target.closest('.dropzone'); }
  document.addEventListener('dragenter', function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault();
    if (depth++ === 0) showOverlay(e);
  });
  document.addEventListener('dragover', function (e) {
    if (!hasFiles(e)) return;
    e.preventDefault();
    if (e.dataTransfer) e.dataTransfer.dropEffect = 'copy';
  });
  document.addEventListener('dragleave', function (e) {
    if (!overlay.classList.contains('on')) return;
    if (--depth <= 0 || e.relatedTarget === null) hideOverlay();
  });
  document.addEventListener('drop', function (e) {
    if (!hasFiles(e)) return;
    hideOverlay(true);
    if (inDropzone(e)) return;   // the tool's own drop zone handles it (the file list observer celebrates)
    e.preventDefault();
    route(e.dataTransfer.files, 'drop');
  });

  /* ---------- 5. paste ---------- */
  document.addEventListener('paste', function (e) {
    var t = e.target;
    if (t && (t.isContentEditable || /^(input|textarea|select)$/i.test(t.tagName) && !/^(file|button|checkbox|radio)$/i.test(t.type || ''))) return;
    var items = (e.clipboardData && e.clipboardData.items) || [], files = [], n = 0;
    [].forEach.call(items, function (it) {
      if (it.kind !== 'file') return;
      var f = it.getAsFile(); if (!f) return;
      if (!f.name || /^image\.(png|jpe?g|gif|webp|bmp)$/i.test(f.name)) {
        var ext = (f.type.split('/')[1] || 'png').replace('jpeg', 'jpg');
        var d = new Date(), pad = function (x) { return ('0' + x).slice(-2); };
        f = new File([f], 'screenshot-' + pad(d.getHours()) + pad(d.getMinutes()) + pad(d.getSeconds()) + (n++ ? '-' + n : '') + '.' + ext, { type: f.type, lastModified: Date.now() });
      }
      files.push(f);
    });
    if (!files.length) return;
    e.preventDefault();
    route(files, 'paste');
  });

  /* ---------- 3. network reacts: files arrive, download ready ---------- */
  function watchPanel(panel) {
    var list = panel.querySelector('.filelist'), result = panel.querySelector('.result-box'), count = 0;
    if (list) new MutationObserver(function () {
      var n = list.children.length;
      if (n > count && panel.classList.contains('active')) celebrateArrival();
      count = n;
    }).observe(list, { childList: true });
    if (result) new MutationObserver(function () {
      if (result.classList.contains('show') && !result.__shown) { result.__shown = true; if (window.PDFC_NET) window.PDFC_NET.flash(); }
      if (!result.classList.contains('show')) result.__shown = false;
    }).observe(result, { attributes: true, attributeFilter: ['class'] });
  }
  [].forEach.call(document.querySelectorAll('.panel'), watchPanel);
  document.addEventListener('pc-panel', function (e) { watchPanel(e.detail); }); // (v116) a panel made when its tab opens

  /* ---------- paste hint in each drop zone (keyboards only) ---------- */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var addHint = function (dz) {
      var p = document.createElement('p');
      p.className = 'sub pc-paste-hint';
      p.textContent = S.hint.replace('{key}', isMac ? '⌘' : LANG === 'de' ? 'Strg' : 'Ctrl');
      dz.appendChild(p);
      // (v61) the drop zone's name is all the text it shows (WCAG 2.5.3, label in name)
      if (dz.id) {
        p.id = dz.id + '-hint';
        var by = dz.getAttribute('aria-labelledby');
        if (by) dz.setAttribute('aria-labelledby', by + ' ' + p.id);
      }
    };
    [].forEach.call(document.querySelectorAll('.panel .dropzone'), addHint);
    document.addEventListener('pc-panel', function (e) { [].forEach.call(e.detail.querySelectorAll('.dropzone'), addHint); }); // (v116)
  }

  /* ---------- 6. opened with the installed app (v95) ----------
     "Open with PDFCommunity" (manifest file_handlers, Chrome/Edge on a
     computer): the PDF goes to the tool like a dropped file. */
  if ('launchQueue' in window) window.launchQueue.setConsumer(function (params) {
    var handles = (params && params.files) || [];
    if (!handles.length) return;
    Promise.all(handles.map(function (h) { return h.getFile(); })).then(function (files) { route(files, 'launch'); }, function (err) {
      stay(S.launchFail);
      if (window.pcLogUnexpected) window.pcLogUnexpected(err);
    });
  });

  receiveHandOff();
})();
